import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox, Form, Input } from 'antd';
import FormLabel from 'components/FormLabel';
import { isValidInviteEmailRaw } from 'utils/inviteEmailInput';
import messages from './messages';

const toOption = (role) => ({ label: role.name, value: role.id });

const InviteUserForm = ({ form, onSubmit, availableRoles = [] }) => {
  useEffect(() => form.resetFields(), []);
  const { formatMessage: $t } = useIntl();

  const roleOpts = availableRoles.map(toOption);

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
    >
      <Form.Item
        name="email"
        label={<FormLabel label={messages.email} />}
        rules={[
          { required: true, whitespace: true, message: $t(messages.emailRequired) },
          {
            validator: (_, value) => {
              const v = String(value ?? '').trim();
              if (!v) return Promise.resolve();
              if (!isValidInviteEmailRaw(v)) {
                return Promise.reject(new Error($t(messages.emailInvalid)));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="roleIds"
        label={<FormLabel label={messages.internalRoles} />}
      >
        <Checkbox.Group options={roleOpts} />
      </Form.Item>
    </Form>
  );
};

export default InviteUserForm;
